<button role="button" class="toggle-checkbox" *ngIf="data" [ngClass]="{'selected': isSelected}" (click)="toggleState()">
  <div class="toggle-checkbox__label">{{data.label}}</div>

  <span class="toggle-checkbox__number-label" *ngIf="numberLabel">{{numberLabel}}</span>

  <div class="toggle-checkbox__switcher">
    <div class="toggle-checkbox__switcher-dot"></div>
  </div>
</button>
